var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNhPlay = function SvgNhPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3796_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.63403C17.9167 10.0189 17.9167 10.9812 17.25 11.3661L7.29849 17.1116C6.63183 17.4965 5.79849 17.0154 5.79849 16.2456L5.79849 4.75456C5.79849 3.98475 6.63183 3.50363 7.29849 3.88853L17.25 9.63403Z",
    stroke: "#1D1D1B",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3796_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.75 0.5)"
  })))));
};
export default SvgNhPlay;